const getReachableNodes = (graph: Map<string, string[]>, startNode: string): string[] => {
  const visited = new Set<string>();
  const stack = [startNode];

  while (stack.length > 0) {
    const node = stack.pop();
    if (!node || visited.has(node)) continue;

    visited.add(node);
    const children = graph.get(node) || [];
    stack.push(...children);
  }

  visited.delete(startNode);
  return Array.from(visited);
};

export const computeTransitiveFields = (graph: Map<string, string[]>): Map<string, string[]> => {
  const result = new Map<string, string[]>();

  graph.forEach((_, node) => {
    const reachable = getReachableNodes(graph, node);
    result.set(node, Array.from(reachable));
  });

  return result;
};
